import { render, staticRenderFns } from "./ContratoDetail.vue?vue&type=template&id=6465d6ea"
import script from "./ContratoDetail.vue?vue&type=script&lang=js"
export * from "./ContratoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports